import { useParams, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {useAuthInfo} from "@propelauth/react";
import {ProjectContext, ProjectContextType} from '../contexts/ProjectContext';
import { fetchWithToken} from "../api/apiBase";

export function ProjectProvider() {
  const { project_id } = useParams<{ project_id: string }>();
  const [permissions, setPermissions] = useState<ProjectContextType | null>(null);
  const [isLoading, setLoading] = useState(true);
  const { accessToken } = useAuthInfo();

  // console.log('here', project_id)
  useEffect(() => {
    setLoading(true);
    // console.log('here2', project_id)
    fetchWithToken(`/permissions/project/${project_id}`, accessToken as string)

      .then((data) => {
        console.log('loaded permissions', data)
        setPermissions(data);
        setLoading(false);
      })
      .catch((e) => {
        // handle error...
        console.log('error getting permissions', e)
        setLoading(false);
      });
  }, [project_id, accessToken]);

  // You can show a spinner or error here
  if (isLoading) return <div>Loading project…</div>;

  return (
      // <></>
    <ProjectContext.Provider
      value={permissions}
    >
      <Outlet />
    </ProjectContext.Provider>
  );
}